<div class="app-container" [class.is-mobile]="mobileQuery.matches">
  <mat-toolbar color="primary" class="app-toolbar toolbar-dense">
    <div class="app-toolbar-sections">
      <!-- Start: Hamburger + Title -->
      <div class="app-toolbar-start">
        <button mat-icon-button (click)="mainSideNav.toggle()"><mat-icon>menu</mat-icon></button>
        <span class="app-toolbar-title" i18n="@@Ecommerce Settings">Ecommerce Settings</span>
      </div>

      <!-- Center: Store selector + Type filter -->
      <div class="app-toolbar-center" *ngIf="ecommerceConnections.length > 1">
        <!-- Store selector -->
        <div class="toolbar-store-select" *ngIf="filteredConnections.length > 1">
          <mat-icon class="toolbar-store-icon">store</mat-icon>
          <span class="toolbar-btn-label toolbar-store-label" i18n="@@Store">Store</span>
          <select class="toolbar-native-select"
                  [ngModel]="selectedEcommerceConnectionId"
                  (ngModelChange)="onStoreSelectChange($event)"
                  i18n-title="@@Select Ecommerce Store" title="Select Ecommerce Store">
            <!--
              `storeLabel`, not `ID`: an organization can have several stores
              of the same type, and the organization name is identical across
              all of them, so the bare id was the only thing that differed -- a
              number the merchant has never seen.
            -->
            <option *ngFor="let ec of filteredConnections" [value]="ec.ID">{{ ec.type | languageString }} {{ ec.storeLabel }} - {{ getOrganizationName(ec) }}</option>
          </select>
        </div>

        <div class="toolbar-divider" *ngIf="filteredConnections.length > 1 && distinctTypes.length > 1"></div>

        <!-- Type filter: buttons (wide) -->
        <ng-container *ngIf="!useFilterSelect && distinctTypes.length > 1">
          <div class="toolbar-filters">
            <button class="toolbar-filter" [class.active]="selectedTypeFilter === 'ALL'" (click)="onTypeFilterChange('ALL')" i18n-title="@@All" title="All">
              <mat-icon>filter_list</mat-icon><span class="toolbar-btn-label" i18n="@@All">All</span>
            </button>
            <button *ngFor="let type of distinctTypes" class="toolbar-filter" [class.active]="selectedTypeFilter === type" (click)="onTypeFilterChange(type)" [title]="type">
              <mat-icon>
                <ng-container [ngSwitch]="type">
                  <ng-container *ngSwitchCase="'SHOPIFY'">shopping_bag</ng-container>
                  <ng-container *ngSwitchCase="'WOOCOMMERCE'">shopping_cart</ng-container>
                  <ng-container *ngSwitchCase="'CSV'">description</ng-container>
                  <ng-container *ngSwitchCase="'FACEBOOK'">share</ng-container>
                  <ng-container *ngSwitchDefault>store</ng-container>
                </ng-container>
              </mat-icon><span class="toolbar-btn-label">{{ type | languageString }}</span>
            </button>
          </div>
        </ng-container>

        <!-- Type filter: select (narrow) -->
        <ng-container *ngIf="useFilterSelect && distinctTypes.length > 1">
          <div class="toolbar-type-select">
            <mat-icon class="toolbar-store-icon">filter_list</mat-icon>
            <span class="toolbar-btn-label toolbar-store-label" i18n="@@Type">Type</span>
            <select class="toolbar-native-select"
                    [ngModel]="selectedTypeFilter"
                    (ngModelChange)="onTypeFilterChange($event)">
              <option value="ALL" i18n="@@All">All</option>
              <option *ngFor="let type of distinctTypes" [value]="type">{{ type | languageString }}</option>
            </select>
          </div>
        </ng-container>
      </div>

      <!-- End -->
      <div class="app-toolbar-end">
        <button class="toolbar-action toolbar-action-primary connect-shopify-toolbar-btn"
                (click)="openConnectShopifyDialog()"
                i18n-title="@@Connect Shopify Store" title="Connect Shopify Store">
          <mat-icon>shopping_bag</mat-icon>
          <span class="toolbar-btn-label" i18n="@@Connect Shopify Store">Connect Shopify Store</span>
        </button>
        <app-shopping-cart-top-bar-button></app-shopping-cart-top-bar-button>
        <app-active-role></app-active-role>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container class="app-sidenav-container" (backdropClick)="mainSideNav.close()" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
    <mat-sidenav opened #mainSideNav [mode]="mobileQuery.matches ? 'over' : 'side'" (keydown.escape)="mainSideNav.close()" [fixedInViewport]="mobileQuery.matches" fixedTopGap="56">
      <mat-nav-list>
        <app-side-nav focus="ecommercesettings"></app-side-nav>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content class="m2app-dark">
      <div class="app-content">
        <div *ngIf="ecommerceConnections.length === 0" class="ecommerce-empty-state">
          <p>
            <span i18n="@@GetStartedWithEcommerce">Get started with an ecommerce store here. For more information visit the guide at </span>
            <a href="https://www.snowfallpress.com/ecommerce" i18n="@@EcommerceGuideLinkName">ecommerce guide</a>.
          </p>
          <button mat-raised-button
                  color="primary"
                  class="ecommerce-empty-state-cta"
                  (click)="openConnectShopifyDialog()">
            <mat-icon>shopping_bag</mat-icon>
            <span i18n="@@Connect Shopify Store">Connect Shopify Store</span>
          </button>
          <p class="ecommerce-empty-state-secondary" i18n="@@AddOtherEcommerceTypeHint">
            To add a CSV, WooCommerce, or other ecommerce connection, contact support.
          </p>
        </div>
        <ng-container *ngIf="selectedEcommerceConnection">
          <ng-container [ngSwitch]="selectedEcommerceConnection.state">
            <ng-container *ngSwitchCase="'ACTIVE'">
              <app-ecommerce-connection [ecommerceConnection]="selectedEcommerceConnection"></app-ecommerce-connection>
            </ng-container>
            <ng-container *ngSwitchCase="'INACTIVE'">
              <div style="padding: 30px; text-align: center; font-size: x-large">
                <p i18n="@@InactiveEcommerceConnection">This ecommerce connection is inactive.  To reactivate the connection click the button below and verify the settings and connection to your ecommerce store.</p>
                <p i18n="@@ActivateEcommerceConnection" style="padding: 50px; background-color: darkgreen; color: white; font-size: xxx-large; text-align: center; vertical-align: center; width: 50%; border-radius: 20px; margin-left: auto; margin-right: auto" (click)="reactivateEcommerceConnection()">Reactivate your ecommerce connection.</p>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
